var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useRouter } from "vue-router/composables";
export function useInstanceRouting() {
    const router = useRouter();
    function goToIndex(query) {
        return __awaiter(this, void 0, void 0, function* () {
            router.push({
                path: "/object_store_instances/index",
                query: query,
            });
        });
    }
    return {
        goToIndex,
    };
}
